module.exports = __webpack_public_path__ + "static/img/logo2.4ad23ca8.png";